import * as React from 'react';
import Select from 'react-select';
import { connect } from 'react-redux';
import { filtroEstadosProveedor } from "../../helper/ordenHelper";
import { fetchSellers, fetchProveedoresFilter } from '../../actions/sellersActions';
import { DropDownArrow, compactFilterSelectStyle, filterSelectMenuPortalProps } from "../../template/CustomStyle";
import { limpiarFiltros } from '../../actions/generalActios';
import { filtroMedioMes } from '../../utilities/fechasFiltro';
import { setFiltroOrdenes } from '../../actions/ordenesActions';
import PropTypes from 'prop-types';
import '../Publicaciones/Components/PublicacionStyles.css';

const fechaFiltro = filtroMedioMes();

class FiltroOrdenes extends React.Component {
    constructor(props) {
        super(props);
        const safeUserType = props.userType || {};
        this.state = {
            cantidadPagina: 10,
            numeroPagina: 1,
            idOrden: "",
            idUsuario: safeUserType.isProveedor ? this.props.idUsuario : "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            entidadOrdenamiento: 1,
            proveedor: {value: "", label: "Todos"},
            codProv: safeUserType.isProveedor ? this.props.codProv : "",
            estado: {value: "", label: "Todos"},
            estadoOblea: "",
            proveedores: []
        }
    };

    componentDidMount() {
        this.setState(this.setFiltrosDesdeProps());
        this.props.fetchProveedoresFilter({ descripcion: "" });
    }

    componentDidUpdate(prevProps) {
        if (this.props.filtro !== prevProps.filtro) {
            this.setState(this.setFiltrosDesdeProps());
        }
    }

    setFiltrosDesdeProps() {
        const filtro = this.props.filtro || {};
        const idUsuario = this.props.idUsuario;
        const userType = this.props.userType || {};

        return {
            fechaDesde: filtro.fechaDesde !== undefined ? filtro.fechaDesde : fechaFiltro.desde,
            fechaHasta: filtro.fechaHasta !== undefined ? filtro.fechaHasta : fechaFiltro.hasta,
            codProv: filtro.codProv !== undefined ? filtro.codProv : (userType.isProveedor ? this.props.codProv : ""),
            idUsuario: userType.isProveedor ? idUsuario : "",
            cantidadPagina: 10,
            numeroPagina: 1,
            idOrden: filtro.idOrden !== undefined ? filtro.idOrden : "",
            proveedor: {
                value: filtro.proveedor !== undefined ? filtro.proveedor.value : "",
                label: filtro.proveedor !== undefined ? filtro.proveedor.label : "Todos"
            },
            estadoOblea: filtro.estadoOblea !== undefined ? filtro.estadoOblea : "",
            estado: {
                value: filtro.estado !== undefined ? filtro.estado.value : "",
                label: filtro.estado !== undefined ? filtro.estado.label : "Todos"
            },
            documento: filtro.documento,
            nombre: filtro.nombre,
            apellido: filtro.apellido,
        };
    }

    myChangeHandler = async (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
        this.props.setFiltroOrdenes({ ...this.props.filtro, [name]: value });
    }

    onSubmit = async (event) => {
        event.preventDefault();

        this.props.limpiarFiltros({
            publicaciones: true,
            ordenes: false,
            proveedores: false,
        });

        const { proveedores, ...restState } = this.state;
        this.props.updateRequest(restState);
    }

    selectSearchHandler = (options, config) => {
        this.setState({ [config.name]: options });
        if (config.name === "estado") {
            this.setState({ estadoOblea: options.value });
        }
        if (config.name === "proveedor") {
            this.setState({ codProv: options.value });
        }
    }

    onSelectSearchInputProveedores = (descripcion) => {
        this.props.fetchProveedoresFilter({ descripcion });
    }

    verTodos = () => {
        const { userType, codProv } = this.props;
        const codProvTrasLimpiar = userType.isProveedor && codProv
            ? codProv
            : "";

        this.setState({
            idOrden: "",
            codProv: codProvTrasLimpiar,
            estadoOblea: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            proveedor: {label: "Todos", value: ""},
            estado: {label: "Todos", value: ""}
        });

        let params = {
            idOrden: "",
            codProv: codProvTrasLimpiar,
            estadoOblea: "",
            documento: "",
            nombre: "",
            apellido: "",
            fechaDesde: fechaFiltro.desde,
            fechaHasta: fechaFiltro.hasta,
            proveedor: {label: "Todos", value: ""},
            estado: {label: "Todos", value: ""},
            cantidadPagina: 10,
            numeroPagina: 1,
            entidadOrdenamiento: 1
        }

        this.props.updateRequest(params);
    }

    mapProveedores = () => {
        // SIEMPRE cargar proveedores cuando se abre el dropdown
        // Esto limpia cualquier filtro previo de otras vistas
        this.props.fetchProveedoresFilter({ descripcion: null });
    }

    render() {
        const { idOrden, proveedor, estado, documento, apellido, fechaDesde, fechaHasta } = this.state;
        const { onMinimize } = this.props;
        let listaProveedor = [];
        if (this.props.proveedores != undefined) {
            this.props.proveedores.map((item) => {
                listaProveedor.push({ label: item.label, value: item.value.toString() })
            })
        }
        
        // Agregar opción "Todos" si no está ya en la lista
        if (listaProveedor.length > 0 && listaProveedor[0]?.value !== "") {
            listaProveedor.unshift({ value: "", label: "Todos" });
        }

        return (
            <div className="card card-body filter-card pub-filter">
                <div className="pub-filter__head">
                    <p className="pub-filter__kicker">Filtros</p>
                    <p className="pub-filter__hint">Todos los campos quedan a la vista para combinarlos.</p>
                </div>
                <form
                    className="pub-filter__form"
                    onSubmit={this.onSubmit}
                    onReset={this.verTodos}
                >
                    <div className="pub-filter__board">
                        <section className="pub-filter__lane pub-filter__lane--id">
                            <h6 className="pub-filter__group-title"><i className="fa fa-barcode" aria-hidden="true" /> Identificadores</h6>
                            <div className="pub-filter__grid">
                                <div>
                                    <label htmlFor="nroOrdenFiltroOrdenes" className="label-oscura">N° Orden</label>
                                    <input
                                        id="nroOrdenFiltroOrdenes"
                                        type="number"
                                        name="idOrden"
                                        className="form-control"
                                        placeholder="Ej: 12345"
                                        value={idOrden == null ? "" : idOrden}
                                        onChange={this.myChangeHandler}
                                        min={0}
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="pub-filter__lane pub-filter__lane--catalog">
                            <h6 className="pub-filter__group-title"><i className="fa fa-users" aria-hidden="true" /> Venta y cliente</h6>
                            <div className="pub-filter__grid">
                                {(this.props.idTipoUsuario === 1 || this.props.idTipoUsuario === 2) && (
                                    <div>
                                        <label htmlFor="proveedoresFiltroOrdenes" className="label-oscura">Proveedores</label>
                                        <Select
                                            inputId="proveedoresFiltroOrdenes"
                                            name="proveedor"
                                            value={proveedor}
                                            options={listaProveedor}
                                            onChange={this.selectSearchHandler}
                                            onMenuOpen={this.mapProveedores}
                                            onInputChange={this.onSelectSearchInputProveedores}
                                            components={{ DropdownIndicator: () => DropDownArrow }}
                                            styles={compactFilterSelectStyle}
                                            {...filterSelectMenuPortalProps}
                                        />
                                    </div>
                                )}
                                <div>
                                    <label htmlFor="estadosFiltroOrdenes" className="label-oscura">Estados</label>
                                    <Select
                                        inputId="estadosFiltroOrdenes"
                                        name="estado"
                                        value={estado}
                                        options={filtroEstadosProveedor}
                                        onChange={this.selectSearchHandler}
                                        components={{ DropdownIndicator: () => DropDownArrow }}
                                        styles={compactFilterSelectStyle}
                                        {...filterSelectMenuPortalProps}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="dniFiltroOrdenes" className="label-oscura">DNI</label>
                                    <input
                                        id="dniFiltroOrdenes"
                                        type="number"
                                        name="documento"
                                        className="form-control"
                                        value={documento == null ? "" : documento}
                                        onChange={this.myChangeHandler}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="apellidoFiltroOrdenes" className="label-oscura">Apellido</label>
                                    <input
                                        id="apellidoFiltroOrdenes"
                                        type="text"
                                        name="apellido"
                                        className="form-control"
                                        value={apellido == null ? "" : apellido}
                                        onChange={this.myChangeHandler}
                                    />
                                </div>
                            </div>
                        </section>

                        <section className="pub-filter__lane pub-filter__lane--period">
                            <h6 className="pub-filter__group-title"><i className="fa fa-calendar" aria-hidden="true" /> Período</h6>
                            <div className="pub-filter__grid">
                                <div>
                                    <label htmlFor="fechaDesdeFiltroOrdenes" className="label-oscura">Fecha desde</label>
                                    <input
                                        id="fechaDesdeFiltroOrdenes"
                                        type="date"
                                        name="fechaDesde"
                                        className="form-control"
                                        value={fechaDesde}
                                        onChange={this.myChangeHandler}
                                    />
                                </div>
                                <div>
                                    <label htmlFor="fechaHastaFiltroOrdenes" className="label-oscura">Fecha hasta</label>
                                    <input
                                        id="fechaHastaFiltroOrdenes"
                                        type="date"
                                        name="fechaHasta"
                                        className="form-control"
                                        value={fechaHasta}
                                        onChange={this.myChangeHandler}
                                    />
                                </div>
                            </div>
                        </section>
                    </div>

                    <div className="pub-filter__actions">
                        <button
                            className="pub-filter__search"
                            disabled={this.props.loadingOrdenes}
                            type="submit"
                        >
                            {this.props.loadingOrdenes ? 'Buscando...' : 'Buscar'}
                        </button>
                        <button className="pub-filter__clear" type="reset">
                            Limpiar
                        </button>
                    </div>
                    {typeof onMinimize === "function" && (
                        <button
                            type="button"
                            className="pub-filter__minimize"
                            onClick={onMinimize}
                        >
                            <i className="fa fa-chevron-up" aria-hidden="true" />
                            Minimizar filtros
                        </button>
                    )}
                </form>
            </div>
        );

    }
}
FiltroOrdenes.propTypes = {
    // Redux props
    idUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    userType: PropTypes.shape({
        isProveedor: PropTypes.bool,
    }),
    codProv: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    filtro: PropTypes.shape({
        fechaDesde: PropTypes.string,
        fechaHasta: PropTypes.string,
        codProv: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        idOrden: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        proveedor: PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        estadoOblea: PropTypes.string,
        estado: PropTypes.shape({
            label: PropTypes.string,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        }),
        documento: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        nombre: PropTypes.string,
        apellido: PropTypes.string,
    }),
    proveedores: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
        proveedores: PropTypes.array,
    })]),
    idTipoUsuario: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    loadingOrdenes: PropTypes.bool,
    onMinimize: PropTypes.func,
    // Actions props
    fetchProveedoresFilter: PropTypes.func,
    setFiltroOrdenes: PropTypes.func,
    limpiarFiltros: PropTypes.func,
    updateRequest: PropTypes.func,
}


const mapStateToProps = state => ({
    userType: state.general.userType || {},
    loadingOrdenes: state.ordenes.loadingOrdenes,
    sellers: state.sellers.filteredSellers,
    estados: state.ordenes.estados,
    idUsuario: state.general.userId,
    proveedores: state.sellers.filteredProveedores,
    filtro: state.ordenes.filtro || {},
    codProv: state.general.codProv,
    idTipoUsuario: state.general.tipoUsuario
});

export default connect(mapStateToProps, {
    fetchSellers,
    fetchProveedoresFilter,
    limpiarFiltros,
    setFiltroOrdenes
})(FiltroOrdenes);